module.exports = __webpack_public_path__ + "img/facebook.679395c8.png";